// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2rwnJ","head":"ProcedureTableInfo_head__2OaYy"};